function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.974 3.161c-.495 0-.897.434-.897.968v7.742c0 .534.402.968.897.968h10.052c.495 0 .897-.434.897-.968V5.677c0-.534-.402-.967-.897-.967H8.718a.52.52 0 01-.38-.17L7.058 3.16H2.974zM1 4.13C1 2.953 1.884 2 2.974 2h4.308a.52.52 0 01.38.17l1.279 1.378h4.085c1.09 0 1.974.954 1.974 2.13v6.193C15 13.047 14.116 14 13.026 14H2.974C1.884 14 1 13.047 1 11.871V4.129zm7 1.742c.297 0 .538.26.538.58v1.743h1.616c.297 0 .538.26.538.58 0 .32-.24.58-.538.58H8.538v1.743c0 .32-.24.58-.538.58-.297 0-.538-.26-.538-.58V9.355H5.846c-.297 0-.538-.26-.538-.58 0-.321.24-.581.538-.581h1.616V6.452c0-.321.24-.581.538-.581z",
  fill: "#2D2D2D"
});
function SvgAgregararchivo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Agregar archivo.svg";
export { SvgAgregararchivo as ReactComponent };